import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {Redirect, RouteComponentProps, withRouter} from 'react-router-dom';
import {ChatModelType} from '../../models/chatModel';
import {ChatChannelKind} from '../../models/chatChannelModel';

type AllChatRouteParams = {
  channelKind: string;
  channelId: string;
};

interface WithInjectedProps extends RouteComponentProps<AllChatRouteParams> {
  chat: ChatModelType;
}

@inject('chat')
@observer
class AllChat extends React.Component<RouteComponentProps, {}> {
  public componentDidMount() {
    const {loadChannels, setCurrentChannelType} = this._withInjectedProps.chat;

    setCurrentChannelType(this._channelKind);
    loadChannels(this._channelKind);
  }

  public render() {
    const {
      chat: {sortedChannels},
      match: {params}
    } = this._withInjectedProps;

    if (sortedChannels && sortedChannels.length > 0 && !params.channelId) {
      return (
        <Redirect
          to={`/messages/${this._channelKind}/${sortedChannels[0].id}`}
        />
      );
    }

    return null;
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private get _channelKind() {
    return (
      (this._withInjectedProps.match.params.channelKind as ChatChannelKind) ||
      ChatChannelKind.EXTERNAL
    );
  }
}

export default withRouter(AllChat);



// WEBPACK FOOTER //
// ./src/pages/AllChat/AllChat.tsx